import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { baseAPI } from '../../../config';
import { getExpedientId } from '../utils/assignmentUtils';
import { buildFilterQueryParams } from '../utils/buildFilterQueryParams';
import useManagementStore from '../../../store/managementStore';
import userStore from '../../../store/userStore';

const LIMIT = 15;

/**
 * Hook to fetch expedients with assignments
 */
export const useAssignmentsFetch = (currentPage, selectedExpedient, handleExpedientSelect) => {
  const { setExpedientsList, setPagination, setLoading } = useManagementStore();
  const [searchParams] = useSearchParams();
  const currentUserId = userStore(state => state.user?.id);

  useEffect(() => {
    const fetchExpedients = async () => {
      try {
        setLoading(true);

        const queryParams = buildFilterQueryParams(searchParams, {
          page: currentPage,
          limit: LIMIT,
          currentUserId,
        });

        const response = await axios.get(`${baseAPI}/assignments/expedients?${queryParams}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const expedients = Array.isArray(response.data?.expedients) ? response.data.expedients : [];

        setExpedientsList(expedients);
        const pagination = response.data?.pagination || {};
        setPagination(pagination.current_page || currentPage, pagination.total_pages || 1);

        // Handle expedient selection after fetch
        if (selectedExpedient) {
          const expedientId = getExpedientId(selectedExpedient);
          const stillExists = expedients.find(exp => getExpedientId(exp) === expedientId);

          if (!stillExists && expedients.length > 0) {
            // Selected expedient no longer in list, select first one
            handleExpedientSelect(expedients[0]);
          }
        } else if (expedients && expedients.length > 0) {
          // Auto-select first expedient if none selected
          handleExpedientSelect(expedients[0]);
        }
      } catch (error) {
        console.error('Error fetching expedients with assignments:', error);
        if (error.response?.status === 403) {
          console.error('Access denied: Admin role required');
        } else if (error.response?.data?.error) {
          console.error('API Error:', error.response.data.error);
        }
        setExpedientsList([]);
      } finally {
        setLoading(false);
      }
    };

    fetchExpedients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, searchParams, currentUserId]);
};
